import IntroAcceuil from './IntroAccueil'
import ProduitsAccueil from './ProduitsAccueil';
import Avantages from './Avantages';
import Avis from './Avis';
import Invitation from './Invitation';

function Accueil() {
    return (
        <>
        <IntroAcceuil />
        <ProduitsAccueil />
        <Avantages />
        <Avis />
        <Invitation />
        </>
    )
}

export default Accueil;
